import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import {
  ForEachModel,
  ModelContext,
  useModel,
  useValue,
  ValueToCollection,
  WhenCollectionIsNotEmpty,
  WhenModelValue
} from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import ShiftExchangeSiblingShift from 'pages/app/shifts/exchange/partials/ShiftExchangeSiblingShift'
import ShiftExchangeEvents from 'pages/app/shifts/exchange/partials/ShiftExchangeEvents'

export default function ShiftExchangeSiblingShifts ({ namePrefix = null }) {
  const parentShiftId = useValue(`${namePrefix}_shift.id`)
  const sellerShiftId = useValue('exchange.seller_shift.id')
  const buyerShiftId = useValue('exchange.buyer_shift.id')
  const model = useModel()

  return (
    <>
      <ShiftExchangeEvents namePrefix={namePrefix} />
      <div className='flex flex-col divide-y'>
        <ValueToCollection name={`${namePrefix}_shift.shifts_of_today`}>
          <WhenCollectionIsNotEmpty>
            <UI.Text block>
              <UI.Text block capitalize weight='medium'>
                <Translation name='shifts.view.title' />
                <span> </span>
                <Displays.Text name={`${namePrefix}_shift.schedule.department.name`} />
              </UI.Text>
              <UI.Text block capitalize size='sm'>
                <Displays.Date name={`${namePrefix}_shift.start_at`} dateFormat='dddd DD.MM.YYYY' />
              </UI.Text>
            </UI.Text>
            <ForEachModel>
              <WhenModelValue
                name='id' condition={id => `${id}` === `${sellerShiftId}` && `${id}` === `${buyerShiftId}`}
                negate
              >
                <ShiftExchangeSiblingShift
                  parentShiftId={parentShiftId}
                  namePrefix={namePrefix}
                />
              </WhenModelValue>
              <WhenModelValue name='id' condition={id => `${id}` === `${sellerShiftId}`}>
                <ModelContext.Provider value={model}>
                  <ShiftExchangeSiblingShift
                    oldShift
                    userNamePrefix={namePrefix === 'exchange.seller' ? 'exchange.seller' : 'exchange.buyer'}
                    shiftNamePrefix={namePrefix === 'exchange.seller' ? 'exchange.seller_shift' : 'exchange.buyer_shift'}
                    parentShiftId={parentShiftId}
                    namePrefix={namePrefix}
                  />
                  <ShiftExchangeSiblingShift
                    newShift
                    userNamePrefix={namePrefix === 'exchange.seller' ? 'exchange.buyer' : 'exchange.seller'}
                    shiftNamePrefix={namePrefix === 'exchange.seller' ? 'exchange.seller_shift' : 'exchange.buyer_shift'}
                    parentShiftId={parentShiftId}
                    namePrefix={namePrefix}
                  />
                </ModelContext.Provider>
              </WhenModelValue>
              <WhenModelValue name='id' condition={id => `${id}` === `${buyerShiftId}`}>
                <ModelContext.Provider value={model}>
                  <ShiftExchangeSiblingShift
                    oldShift
                    userNamePrefix={namePrefix === 'exchange.seller' ? 'exchange.buyer' : 'exchange.seller'}
                    shiftNamePrefix={namePrefix === 'exchange.seller' ? 'exchange.buyer_shift' : 'exchange.seller_shift'}
                    parentShiftId={parentShiftId}
                    namePrefix={namePrefix}
                  />
                  <ShiftExchangeSiblingShift
                    newShift
                    userNamePrefix={namePrefix === 'exchange.seller' ? 'exchange.seller' : 'exchange.buyer'}
                    shiftNamePrefix={namePrefix === 'exchange.seller' ? 'exchange.buyer_shift' : 'exchange.seller_shift'}
                    parentShiftId={parentShiftId}
                    namePrefix={namePrefix}
                  />
                </ModelContext.Provider>
              </WhenModelValue>
            </ForEachModel>
          </WhenCollectionIsNotEmpty>
        </ValueToCollection>
      </div>
    </>
  )
}
